import { USDZExporter } from 'three-stdlib';
import { Scene } from 'three';

export const exportUSDZUrl = async (scene: Scene): Promise<string> => {
  const exporter = new USDZExporter();
  const arraybuffer = await exporter.parse(scene);
  const blob = new Blob([arraybuffer], { type: 'application/octet-stream' });
  return URL.createObjectURL(blob);
}
